import User from "@/models/User";


export default {
    state: {
        user: new User(),
        users: new Array(),
    },
    getters:{
        getUser(state){
            return state.user;
        },
        getUsers(state){
            return state.users
        },
    },
    mutations: {
        setUser(state,dado){
            state.user = JSON.parse(JSON.stringify(dado? dado : new User()));
        },
        setUsers(state,dados){
            state.users = dados
        },
    },
    actions: {
        setUser({commit}, dado){
            commit('setUser', dado);
        },
        setUsers({commit}, dados){
            commit('setUsers', dados);
        }
    },
}